import {ValueObject} from '@s-ui/domain'

export class LoanCalculationsB2CTransactionsRequest extends ValueObject {
  /**
   * @param {String} loanId
   **/

  static validate({adId, entry, terms, withLifeInsurance, lender, validationError}) {
    const getInvalidParam = param => param === undefined || param === null || param === ''
    if (getInvalidParam(adId)) throw validationError('adId is required')
    if (getInvalidParam(entry)) throw validationError('entry is required')
    if (getInvalidParam(terms)) throw validationError('terms is required')
    if (getInvalidParam(withLifeInsurance)) throw validationError('withLifeInsurance is required')
    if (getInvalidParam(lender)) throw validationError('lender is required')
  }
}
